import lodashHas from "lodash/has";
import { ENDPOINT_CR_INCIDENTS } from "@/common/constants/api";
import { encodeAllURLParameters } from "@/common/api.utilities";
import { httpGet } from "@/services/api.service";
import POLITICAL_CATEGORIES from "../../common/constants/controlRisks/IncidentsPoliticalCategories.js";
import MARITIME_CATEGORIES from "../../common/constants/controlRisks/IncidentsMaritimeCategories.js";
import GenericPoliticalMapMarker from "../../assets/images/icons/controlRisksIncidents/security/map/Generic.svg";
import GenericMaritimeMapMarker from "../../assets/images/icons/controlRisksIncidents/maritime/map/Generic.svg";

export { _getIncidents as getIncidents };
export { _getClusteredIncidents as getClusteredIncidents };
export { _incidentsToFeatures as incidentsToFeatures };
export { _getIncidentById as getIncidentById };
export { _getCategoryIcon as getCategoryIcon };
export { _loadCategoryIcons as loadCategoryIcons };

const ICON_PREFIX = "cr_incidents_";
const GENERIC_POLITICAL_ICON_ID = ICON_PREFIX + "_political_generic";
const GENERIC_MARITIME_ICON_ID = ICON_PREFIX + "_maritime_generic";

const _getIncidents = async (params) => {
  try {
    let categoryType = params.maritimeEnabled ? "/maritime" : "/political";
    params.language = "en";
    if (
      params.countriesCode &&
      Array.isArray(params.countriesCode) &&
      params.countriesCode.length &&
      params.bounds
    ) {
      delete params.bounds;
    }
    const url = encodeAllURLParameters({
      baseEndpoint: `${ENDPOINT_CR_INCIDENTS}${categoryType}`,
      params: params,
      isIncidents: true,
    });

    const RESULT = await httpGet({ url: url, xApiKey: true });
    const { data } = JSON.parse(RESULT);

    const incidents = data;

    // _formatFeatures(incidents, requestTimestamp);

    return incidents;
  } catch (error) {
    Promise.reject(
      "Issue getting incidents in incidents.service.js: " +
        JSON.stringify(error)
    );
    return null;
  }
};

const _getIncidentById = async (incidentId, isMaritime) => {
  try {
    let catType = isMaritime ? "maritime" : "political";
    let url = `${ENDPOINT_CR_INCIDENTS}/${catType}/${incidentId}`;

    let res = await httpGet({ url: encodeURI(url), xApiKey: true });
    res = JSON.parse(res);
    return res.data;
  } catch (error) {
    Promise.reject(
      "Issue in _getIncidentById in incidents.service.js: " +
        JSON.stringify(error)
    );
  }
};

const _getCategoryIdByName = (name, isMaritime) => {
  let checkList = isMaritime ? MARITIME_CATEGORIES : POLITICAL_CATEGORIES;
  for (let i = 0; i < checkList.length; i++) {
    if (checkList[i].Name === name) {
      return checkList[i].Id;
    }
  }
};

const _getClusteredIncidents = async (params) => {
  try {
    let categoryType = params.maritimeEnabled ? "/maritime" : "/political";
    params.language = "en";
    let url = encodeAllURLParameters({
      baseEndpoint: `${ENDPOINT_CR_INCIDENTS}/clusters${categoryType}`,
      params: params,
      isIncidents: true,
    });

    let res = await httpGet({ url: url, xApiKey: true });
    res = JSON.parse(res);
    return res.data;
  } catch (error) {
    Promise.reject(
      "Issue getting clustered incidents in incidents.service.js: " +
        JSON.stringify(error)
    );
    return null;
  }
};

const _incidentsToFeatures = (data, isMaritime) => {
  let res = [];
  if (data && data.Clusters) {
    let clusters = data.Clusters;
    for (let i = 0; i < clusters.length; i++) {
      let cur = clusters[i];
      cur.icon = _getIconNameFromIncident(cur, isMaritime);
      res.push({
        type: "Feature",
        properties: cur,
        geometry: {
          type: "Point",
          coordinates: [cur.Center.Lon, cur.Center.Lat],
        },
      });
    }
  }

  if (data && data.Markers) {
    let features = data.Markers;
    for (let i = 0; i < features.length; i++) {
      let cur = features[i];
      cur.icon = _getIconNameFromIncident(cur, isMaritime);
      res.push({
        type: "Feature",
        properties: cur,
        geometry: {
          type: "Point",
          coordinates: [cur.Lon, cur.Lat],
        },
      });
    }
  }
  return res;
};

const _getIconNameFromIncident = (incident, isMaritime) => {
  if (lodashHas(incident, "Categories[0]")) {
    return (
      ICON_PREFIX + _getCategoryIdByName(incident.Categories[0], isMaritime)
    );
  }
  if (lodashHas(incident, "Category")) {
    return ICON_PREFIX + _getCategoryIdByName(incident.Category, isMartiime);
  }
  return isMaritime ? GENERIC_MARITIME_ICON_ID : GENERIC_POLITICAL_ICON_ID;
};

const _getCategoryIcon = (categoryId, kind) => {
  kind = kind ? kind : "Big";
  for (let i = 0; i < POLITICAL_CATEGORIES.length; i++) {
    if (categoryId === POLITICAL_CATEGORIES[i].Id) {
      return POLITICAL_CATEGORIES[i].Icons[kind];
    }
  }
  for (let i = 0; i < MARITIME_CATEGORIES.length; i++) {
    if (categoryId === MARITIME_CATEGORIES[i].Id) {
      return MARITIME_CATEGORIES[i].Icons[kind];
    }
  }
};

const _loadMapIcon = (map, id, src) => {
  let img = new Image();
  img.onload = () => {
    map.addImage(id, img);
  };
  img.src = src;
};

const _loadCategoryIcons = (map) => {
  for (let i = 0; i < POLITICAL_CATEGORIES.length; i++) {
    _loadMapIcon(
      map,
      ICON_PREFIX + POLITICAL_CATEGORIES[i].Id,
      POLITICAL_CATEGORIES[i].Icons.Map
    );
  }
  _loadMapIcon(map, GENERIC_POLITICAL_ICON_ID, GenericPoliticalMapMarker);
  for (let i = 0; i < MARITIME_CATEGORIES.length; i++) {
    _loadMapIcon(
      map,
      ICON_PREFIX + MARITIME_CATEGORIES[i].Id,
      MARITIME_CATEGORIES[i].Icons.Map
    );
  }
  _loadMapIcon(map, GENERIC_MARITIME_ICON_ID, GenericMaritimeMapMarker);
};
